import gql from 'graphql-tag'

export const GET_VEIL = gql`
  query {
    veil @client {
      active
    }
  }
`

export const TOGGLE_VEIL = gql`
  mutation toggleVeil($active: Boolean) {
    toggleVeil(active: $active) @client
  }
`
